module.exports = __webpack_public_path__ + "img/falken_white.e6eda4cf.svg";